module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part01"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#/004toc#january"
    }
  }, [_vm._v("JANUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Month of Plagues")]), _vm._v(" "), _c('p', {
    staticClass: "white1"
  }), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image2"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 2",
      "src": "images/image-5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "white1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Capricorn:")]), _vm._v(" January 1–20 • "), _c('b', [_vm._v("Aquarius:")]), _vm._v(" January 21–31")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image3"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 3",
      "src": "images/image-5b.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Plant to Avoid:")]), _vm._v(" Wolfsbane")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Doomsday Device:")]), _vm._v(" Icicle machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Evil Omen:")]), _vm._v(" Pentagram-shaped snowflake")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0e652b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005part01.vue
// module id = 69
// module chunks = 0